// extracted by mini-css-extract-plugin
export default {"link":"AC-z","disabled":"BC-z"};